<template>
  <div
    class="glass-frosted p-6 rounded-6xl flex flex-col items-center text-s-medium text-text-explanatory-default w-full"
  >
    <img
      :src="getImageUrl('header/configurations/empty-bot.webp')"
      alt="empty"
      class="w-full object-contain max-h-75"
    />
    <p class="text-black-white text-m-medium">
      {{ messageKey ? $t(messageKey) : $t('home.emptyState.notFoundConfig') }}
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { getImageUrl } from '@/utils/assets'

  interface Props {
    /** 自定义多语言 key，优先显示此 key 对应的文案，为空时使用默认的 notFoundConfig */
    messageKey?: string
  }
  defineProps<Props>()
</script>

<style lang="scss" scoped></style>
